import Services from "../services/Services";
import DAO from "../DAO/DAO";
import { setPermissions } from "../middlewares/permissions_control/permissions";
import StringHelper from "../helpers/StringHelper";
import Usuario from "./Usuario";
import Colaborador from "./Colaborador";

export default class Autenticacao {
	static async acesssar(cpf, senha) {
		cpf = StringHelper.alphanumericOnly(cpf);

		const loginResponse = await Services.AutenticacaoService.login({
			cpf,
			senha
		});
		const { token } = loginResponse;

		return await Autenticacao.autenticarUsuario(token);
	}

	static async autenticarUsuario(token) {
		const usuario = await Autenticacao.getUsuarioAutenticado(token);

		// usuario.isSuperUser = false;

		DAO.user.set(usuario);

		if (usuario.isSuperUser) {
			setPermissions({
				autenticado: {
					superuser: true
				}
			});
		} else if(Colaborador.quantidadeColaboradores > 1) {
			setPermissions({
				autenticado: {
					ver: true
				}
			});
		} else if (Colaborador.quantidadeColaboradores == 1) {
			Colaborador.setColaborador(usuario.colaboradores[0]);
		}

		return {
			navigate: callback => Autenticacao._navigate(usuario, callback)
		};
	}

	static async getUsuarioAutenticado(token) {
		let usuario = await Services.AutenticacaoService.usuarioAutenticado(
			token
		);
		usuario = Usuario.fromMap(usuario);
		return usuario;
	}

	static async sair() {
		try {
			return await Services.AutenticacaoService.logout();
		} catch (error) {
			console.error(error);
		}
	}

	static async recuperarSenha(cpf, email) {
		cpf = StringHelper.alphanumericOnly(cpf);
		await Services.AutenticacaoService.recuperarSenha({ cpf, email });
	}

	static async verificarPkParaRedefinicaoDeSenha(pk) {
		try {
			const verificacaoResponse = await Services.AutenticacaoService.verificarPkParaRedefinicaoDeSenha(
				pk
			);
			return verificacaoResponse;
		} catch (error) {
			if (error && error.response && error.response.status == 404) {
				throw error;
			}
			return false;
		}
	}

	static validarSenhas(novaSenha, confirmarSenha) {

		if (!novaSenha && !confirmarSenha) {
			throw {
				fields_errors: [
					{
						field: "senha",
						errors: [
							{
								message: "Este campo é obrigatório.",
								code: "required"
							}
						]
					},
					{
						field: "confirmar_senha",
						errors: [
							{
								message: "Este campo é obrigatório.",
								code: "required"
							}
						]
					}
				]
			};
		} else if (!novaSenha) {
			throw {
				fields_errors: [
					{
						field: "senha",
						errors: [
							{
								message: "Este campo é obrigatório.",
								code: "required"
							}
						]
					}
				]
			};
		} else if (!confirmarSenha) {
			throw {
				fields_errors: [
					{
						field: "confirmar_senha",
						errors: [
							{
								message: "Este campo é obrigatório.",
								code: "required"
							}
						]
					}
				]
			};
		}

		if (novaSenha !== confirmarSenha) {
			throw {
				error: { message: "As senhas estão diferentes." }
			};
		}
	}

	static messageErrorRedefinirSenha(error) {
		try {
			error.fields_errors.forEach(fieldErro => {
				const fields_errors = [];

				fieldErro.errors.forEach((erro, index) => {
					if ("password" in erro) {
						erro["password"].forEach(messageErro => {
							fields_errors.push({
								message: messageErro
							});
						});

						fieldErro.errors.splice(index, 1);
					}
				});

				fieldErro.errors = [...fieldErro.errors, ...fields_errors];
			});
		} catch (error) {
			return null;
		}
	}

	static async redefinirSenha(pk, senha) {
		const redefinicaoResponse = await Services.AutenticacaoService.redefinirSenha(
			pk,
			{ senha }
		);
		return redefinicaoResponse;
	}

	static _navigate(usuario, callback) {
		if (typeof callback === "function") {

			if (
				usuario.isSuperUser ||
				Colaborador.quantidadeColaboradores > 1
			) {
				callback({ routeName: "empresa-listar", params: {} });
			} else if (Colaborador.quantidadeColaboradores == 1) {
				const colaborador = Colaborador.getColaborador();
				const empresa = colaborador.empresa;

				callback({
					routeName: "empresa-prazo-calendario",
					params: {
						empresaPk: empresa.pk
					}
				});
			} else {
				callback({ routeName: "logout", params: {} });
			}
		} else {
			throw Error(
				"Função de callback não fornecida. O método navigate espera uma função de callback como parametro."
			);
		}
	}
}
